<template>
    <b-navbar v-bind:class="{'navbar':true, 'navbar-shadow':(scrollPosition < 150 ? false : true)}" toggleable="lg" :variant="scrollPosition < 150 ? 'transparent' : 'white'" :sticky="true">
      <b-navbar-brand>
        <img src="@/assets/logo.svg" class="navbar-logo d-inline-block align-top" alt="Dimsi">
      </b-navbar-brand>

      <!-- <b-button class="navButton ml-auto mr-1 d-block d-sm-block d-md-block d-lg-none" href="https://manager.dimsi.io" variant="outline-primary">
        <b-icon icon="person-fill" aria-hidden="true"></b-icon>
      </b-button> -->

      <b-navbar-toggle target="nav-collapse">
        <template #default="{}">
          <b-icon style="font-size: 25px;" icon="list"></b-icon>
        </template>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
            <b-button href="#introduction" class="navButton small-navButton btn-change4" variant="transparent">{{ $t('navbar.introduction') }}</b-button>
            <b-button href="#features" class="navButton small-navButton btn-change4" variant="transparent">{{ $t('navbar.features') }}</b-button>
            <b-button href="#contact" class="navButton small-navButton btn-change4" variant="transparent">{{ $t('navbar.contact') }}</b-button>
            <b-button class="navButton small-navButton btn-change4" href="https://calculator.dimsi.io" target="_blank" variant="transparent">{{ $t('navbar.pricing') }}</b-button>
            
            <b-dropdown size="sm" class="navButton m-2" id="dropdown-1" variant="outline-primary" :text="$t('navbar.customerSpace')">
              <b-dropdown-item href="https://manager.dimsi.io">Cloud Manager</b-dropdown-item>
              <b-dropdown-item href="https://support.dimsi.io">Support</b-dropdown-item>
              <b-dropdown-item href="https://dimsicloud.statuspage.io/" target="_blank">{{ $t('navbar.statuspage') }}</b-dropdown-item>
            </b-dropdown>
            
            <!-- <b-button class="navButton d-md-none d-none d-lg-block d-xl-block" href="https://manager.dimsi.io" target="_blank" variant="outline-primary">
              <b-icon icon="person-fill" aria-hidden="true"></b-icon>
              {{ $t('navbar.customerSpace') }}
            </b-button> -->
            <b-nav-item-dropdown right>
              <template #button-content>
                <b style="color: #090739;">{{ $i18n.locale.toUpperCase() }}</b>
              </template>
              <b-dropdown-item @click="$i18n.locale = 'en'">English</b-dropdown-item>
              <b-dropdown-item @click="$i18n.locale = 'fr'">Français</b-dropdown-item>
            </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
</template>
<script>
export default {
  data() {
    return {
      scrollPosition: null
    }
  },
  mounted () {
    window.addEventListener('scroll', this.updateScroll);
  },
  methods: {
    updateScroll() {
        this.scrollPosition = window.scrollY
    }
  }
}
</script>
